"use strict";

(function () {
  var currentIndex = 0;
  var carousel = document.querySelector('.c-testimonials__carousel');
  var slides = document.querySelectorAll('.c-testimonial[data-slide]');
  var tabs = document.querySelectorAll('.c-testimonials__tab');
  var dots = document.querySelectorAll('.c-testimonial__dot');
  var prevBtn = document.querySelector('.c-testimonials__arrow--prev');
  var nextBtn = document.querySelector('.c-testimonials__arrow--next');

  if (!slides.length) return;

  function scrollTabIntoView(tabElement) {
    if (!tabElement || !tabElement.parentElement) return;
    var containerRect = tabElement.parentElement.getBoundingClientRect();
    var tabRect = tabElement.getBoundingClientRect();
    var fullyVisible = tabRect.left >= containerRect.left && tabRect.right <= containerRect.right;
    if (!fullyVisible) {
      tabElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }

  function goToSlide(index) {
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;
    currentIndex = index;

    slides.forEach(function (slide) {
      slide.classList.remove('c-testimonial--active');
    });
    slides[currentIndex].classList.add('c-testimonial--active');

    tabs.forEach(function (tab) {
      tab.classList.remove('c-testimonials__tab--active');
    });
    if (tabs[currentIndex]) {
      tabs[currentIndex].classList.add('c-testimonials__tab--active');
      scrollTabIntoView(tabs[currentIndex]);
    }

    dots.forEach(function (dot) {
      dot.classList.remove('c-testimonial__dot--active');
    });
    var activeDots = slides[currentIndex].querySelectorAll('.c-testimonial__dot');
    if (activeDots[currentIndex]) {
      activeDots[currentIndex].classList.add('c-testimonial__dot--active');
    }
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var index = parseInt(tab.dataset.slideIndex, 10);
      goToSlide(index);
    });
  });

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      var index = parseInt(dot.dataset.dotIndex, 10);
      goToSlide(index);
    });
  });

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      goToSlide(currentIndex - 1);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      goToSlide(currentIndex + 1);
    });
  }

  if (carousel) {
    var touchStartX = 0;
    var touchStartY = 0;
    var SWIPE_THRESHOLD = 50;
    var VERTICAL_LIMIT = 75;

    carousel.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });

    carousel.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dy) > VERTICAL_LIMIT) return;
      if (dx < -SWIPE_THRESHOLD) {
        goToSlide(currentIndex + 1);
      } else if (dx > SWIPE_THRESHOLD) {
        goToSlide(currentIndex - 1);
      }
    }, { passive: true });
  }
})();
